import angular from 'angular';
import uiRouter from 'angular-ui-router';
import cashboxComponent from './cashbox.component';
import dataTable from 'angular-material-data-table';

let cashboxModule = angular.module('cashbox', [
    uiRouter,
    dataTable
])

.config(($stateProvider) => {
  'ngInject';
  $stateProvider
    .state('cashbox', {
        url: '/cashbox',
        component: 'cashbox',
        parent: 'main',
        data: {
            permissions: {
                only: ['OPERATOR'],
                redirectTo: 'home'
            }
        },
        resolve: {
            cashboxes: (CashboxesService) => {
                return CashboxesService.getModels({
                    include: ['employee']
                });
            }
        }
    });
})
.component('cashbox', cashboxComponent)
.name;

export default cashboxModule;
